import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'outline' | 'default' | 'link';
  children?: React.ReactNode;
}
export function Button({ variant = 'default', children, ...props }: ButtonProps) {
  const baseClasses =
    variant === 'outline'
      ? 'border border-gray-300'
      : variant === 'link'
      ? 'bg-transparent text-blue-600 underline'
      : 'bg-gray-800 text-white'; // Updated color

  return (
    <button className={`px-4 py-2 rounded flex items-center ${baseClasses}`} {...props}>
      {children}
    </button>
  );
}

export function ArrowRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  );
}

export function Card({ children }: { children?: React.ReactNode }) {
  return <div className="border shadow-sm rounded p-4">{children}</div>;
}

export function CardContent({ children, className }: { children?: React.ReactNode; className?: string }) {
  return <div className={className}>{children}</div>;
}

export function Logo({ color = 'black' }: { color?: string }) {
  return <img 
    src="/ff-automaton-logo.jpg" 
    alt="FF Automaton Logo" 
    className="w-24 h-auto rounded-full border-2 border-gray-200 p-2" 
  />;
}


export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input className="border p-2 rounded w-full" {...props} />;
}

export function Textarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className="border p-2 rounded w-full" {...props} />;
}